import {  Route,Redirect } from 'react-router-dom';
import React from 'react';


export const PrivateRouteAuth = ({login, component: Component, ...rest }) => {
  console.log(login)
    return (
      <Route
        {...rest}
        render={props =>
          !login  ? (
            <Component {...props} />
          ) : (
            <Redirect
              to={{
                pathname: "/",
              }}
            />
          )
        }
      />
    );
  }